let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fjNLR")).then(() => parcelRequire('ep2qs'));